import { useContext } from 'react';

import { UscgMapContext } from './uscgMapContextObject';
import type { UscgMapContextType } from './UscgMapContext';

/**
 * Nullable map-context reader for consumers that render both on and off the map
 * page (PRATUS AI drawer). Lives beside the context object rather than in
 * `UscgMapContext.tsx` so importing it does not pull ArcGIS and the map-sync
 * hooks into the consumer's bundle; the type import is erased at build time.
 */
export const useOptionalUscgMapContext = (): UscgMapContextType | null =>
  (useContext(UscgMapContext) as UscgMapContextType | undefined) ?? null;
